/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for ActivityTypeResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetActivityTypesResponse, GetActivityTypeSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class ActivityTypeResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getActivityTypes(resourceOptions: HttpResourceOptions<GetActivityTypesResponse, unknown> & { defaultValue: NoInfer<GetActivityTypesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetActivityTypesResponse>;
    getActivityTypes(resourceOptions?: HttpResourceOptions<GetActivityTypesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetActivityTypesResponse | undefined>;
    getActivityTypes(resourceOptions?: HttpResourceOptions<GetActivityTypesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetActivityTypesResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/ActivityType`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getActivityTypeSelect(resourceOptions: HttpResourceOptions<GetActivityTypeSelectResponse, unknown> & { defaultValue: NoInfer<GetActivityTypeSelectResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetActivityTypeSelectResponse>;
    getActivityTypeSelect(resourceOptions?: HttpResourceOptions<GetActivityTypeSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetActivityTypeSelectResponse | undefined>;
    getActivityTypeSelect(resourceOptions?: HttpResourceOptions<GetActivityTypeSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetActivityTypeSelectResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/ActivityType/Select`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
